// extracted by mini-css-extract-plugin
export default {"form_input":"splitModal_form_input__1xfMs","submit_btn":"splitModal_submit_btn__mGGfG"};